import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const styles = {
  grid: {
    padding: "0 15px"
  }
};

const useStyles = makeStyles(styles);




export default function GridItem(props) {
  const classes = useStyles();
  const { children,className, ...rest } = props;

  const gridClasses = classNames({
    [classes.grid]: true,
    [className]: className
  });
  return (
    <Grid item {...rest} className={gridClasses} >
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
